/**
 * Tokens de diseño "Happy Puppy" del prototipo `commercial-command-center`.
 *
 * Se exponen como constantes locales al feature para no tocar el theme global
 * de styled-components. Cualquier ajuste de colores del panel vive aquí.
 */

export const panelTheme = {
    colors: {
        violet: '#7C3AED',
        indigo: '#4F46E5',
        blueDeep: '#1E40AF',
        blue: '#1E7BFF',
        gold: '#D4A017',

        background: '#F7F6FB',
        surface: '#FFFFFF',
        surfaceMuted: '#F4F2F9',
        border: '#E4E1EE',
        borderStrong: '#C9C2E0',
        text: '#1F1A33',
        textMuted: '#6B6485',
        textInverse: '#FFFFFF',

        success: '#10B981',
        warning: '#F59E0B',
        danger: '#EF4444',

        statusActive: '#10B981',
        statusInactive: '#9CA3AF',
        statusBlocked: '#EF4444',
    },
    radius: {
        sm: '6px',
        md: '10px',
        lg: '14px',
        pill: '999px',
    },
    shadow: {
        sm: '0 1px 2px rgba(31, 26, 51, 0.04)',
        md: '0 6px 18px rgba(31, 26, 51, 0.08)',
        lg: '0 12px 32px rgba(31, 26, 51, 0.12)',
    },
    spacing: (n: number) => `${n * 4}px`,
};

export type PanelTheme = typeof panelTheme;
